export const formatRating = (rating: number, decimal = 0) =>
  rating.toFixed(decimal);
